export default {
      id: "multi_chart-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#multi_chart",
      toString: function () {
        return this.url;
      }
    }